<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.taxes') }} > {{ $t('sidebar.all') }}
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <!-- <pre>{{ taxes }}</pre> -->

      <div
        v-if="ready"
        class="col-md-12 no-padding">
        <table
          class="table table-bordered"
          style="width: 100%;">
          <thead>
            <tr>
              <th>{{ $t('message.tax') }}</th>
              <th
                class="text-center"
                style="width: 150px;">{{ $t('message.tax_type') }}</th>
              <th
                class="text-center"
                style="width: 150px;">{{ $t('apps.product.message.group') }}</th>
              <th
                class="text-center"
                style="width: 150px;">{{ $t('message.tax_amount') }}</th>
              <th
                class="text-center"
                style="width: 150px;">{{ $t('message.status') }}</th>
              <th
                class="text-center"
                style="width: 150px;">{{ $t('message.assignitems') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in taxes"
              :key="index">
              <td>
                <router-link
                  :to="{
                    name: 'TaxEdit',
                    query: {
                      tax_id: item.tax_id,
                      tax_name: getMasterDataText(item.tax_name, $t)
                    }
                }">
                  {{ getMasterDataText(item.tax_name, $t) }}
                </router-link>
              </td>
              <td
                class="text-center"
                style="width: 150px;">
                {{ getTaxType(item.form_type) }}
              </td>
              <td
                class="text-center"
                style="width: 150px;">
                <span
                  v-if="item.group_name"
                  class="badge badge-secondary">
                  {{ item.group_name }}
                </span>
              </td>
              <td
                class="text-center"
                style="width: 150px;">
                {{ item.amount }}%
              </td>
              <td
                class="text-center"
                style="width: 150px;">
                <div
                  v-if="item.is_active"
                  class="text-success">
                  <i class="fas fa-check"/>
                  {{ $t('message.enabled') }}
                </div>
                <div
                  v-else
                  class="text-danger">
                  <i class="fas fa-times"/>
                  {{ $t('message.disabled') }}
                </div>
              </td>
              <td
                class="text-center"
                style="width: 150px;">
                {{ item.assign.length }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'
import userPermissionMixin from '@/mixins/userPermission'
import { TAX_FORM_TYPE } from '@/helpers/enum'
import { getMasterDataText } from '@/helpers'

export default {
  name: 'TaxAll',
  mixins: [userPermissionMixin],
  data () {
    return {
      getMasterDataText,
      ready: false,
    }
  },
  computed: mapGetters({
    taxes: 'getTaxes',
    currency: 'getCurrency',
  }),
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
      // dataTable option
      let option = this.dataTableOption()
      // set dataTable
      setTimeout(() => { $('#dataTable').DataTable(option) }, 1)
    },
  },
  beforeCreate: function () { // clear states

  },
  created: async function () { // call api to get data and set state
    // get taxes
    await this.$store.dispatch('getTaxes')
    // set ready
    this.ready = true
  },
  beforeMount: function () { // set states ui
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.accounts.title'),
      current: {
        app_name: 'accounts',
        app_id: 12,
        module_id: 8,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 6,
      submenuAtIdx: 0,
    })
  },
  destroyed: function () { // leave this page
    this.leavePage(this.$Progress, ['clearTaxes'])
  },
  methods: {
    getTaxType(formType) {
      const patt = {
        [TAX_FORM_TYPE.TAX]: this.$t('apps.product.message.typetax'),
        [TAX_FORM_TYPE.SERVICE_CHARGE]: this.$t('apps.product.message.typeservicecharge'),
        [TAX_FORM_TYPE.FEE]: this.$t('apps.product.message.typefee'),
      }
      return patt[formType]
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/apps/accounts/tax/All.vue